import Image from 'next/image';

export function CompanyInfoCard() {
  return (
    <div className='flex flex-col items-start max-w-[436px] mb-6 md:mb-0'>
      <div className='flex md:flex-col flex-row md:items-start items-center gap-4 md:gap-6 md:mt-8 mb-4 md:mb-6'>
        <Image
          src='/images/logo/logo-secondary.png'
          alt='ClovisClassics Logo'
          width={96}
          height={56}
          priority
          quality={100}
        />
        <p className='text-sm font-bold text-black'>ClovisClassics, Inc.</p>
      </div>

      <ul className='text-sm text-black list-disc pl-6'>
        <li>Clovis Classics</li>
        <li>516 5th Street #202, Clovis, CA 93612</li>
        <li>legal@clovisclassics.com</li>
        <li>clovisclassics.com</li>
      </ul>
    </div>
  );
}
